export default __webpack_public_path__ + "static/1_KV iMedical Card Elite 6000px 1480px BM-af88d2c9eafb4677f7cdf22a19e6dad3.png";